export const selectGenerativeAi = (state) => state.generativeAi;
export const selectGenerativeAiSettings = (state) =>
  state.generativeAi.settings;
export const selectIsGenerativeAiEnabled = (state) =>
  state.generativeAi.settings.isEnabled;
export const selectIsAiEnabledInitialized = (state) =>
  state.generativeAi.isAiEnabledInitialized;
export const selectIsRagEnabled = (state) =>
  state.generativeAi.settings.isRagEnabled;
export const selectIsLocalFileSharingEnabled = (state) =>
  state.generativeAi.settings.ragSettings?.isLocalFileSharingEnabled;
export const selectIsSharepointDownloadEnabled = (state) =>
  state.generativeAi.settings.isSharepointDownloadEnabled;
export const selectIsLlmAvailable = (state) =>
  state.generativeAi.isLlmAvailable;
export const selectIsOutlineGenerationAvailable = (state) =>
  state.generativeAi.isOutlineGenerationAvailable;
export const selectAnalysisLlm = (state) => state.generativeAi.analysisLlm;
export const selectIsAnalysisLlmEnabled = (state) =>
  state.generativeAi.analysisLlm?.enabled ?? false;
export const selectAnalysisAdminEnabled = (state) =>
  state.generativeAi.analysisLlm?.adminEnabled ?? true;
export const selectVisiEverywhereFeature = (state) =>
  state.generativeAi.visiEverywhere;
export const selectIsVisiEverywhereEnabled = (state) =>
  state.generativeAi.visiEverywhere?.enabled ?? false;
// Null when Visi Everywhere has no provider of its own and falls back to the instance one.
export const selectVisiEverywhereProviderSettings = (state) =>
  state.generativeAi.visiEverywhereProvider;
